import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import XLSX_STYLE from 'xlsx-js-style';

export default {
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
    },
    methods: {
        async onExport() {
            const wb = XLSX_STYLE.utils.book_new();
            const ws = this.getExcelSheet();

            XLSX_STYLE.utils.book_append_sheet(wb, ws, '無法停用原因列表');
            XLSX_STYLE.writeFile(wb, `${moment().format('YYYY-MM-DD')}無法停用原因列表.xlsx`);
        },
        getExportDataRows() {
            return _.chain(this.validateItems)
                .map((o) => ({
                    tag: o.data === false || o.data.length === 0 ? '通過' : '未通過',
                    label: o.label,
                    data: this.getMappedData(o.data),
                }))
                .flatMap((o) => {
                    const base = { column1: o.tag, column2: o.label, column3: '' };

                    if (typeof o.data === 'boolean') return base;

                    const returnData = [base];
                    o.data.forEach((item) => {
                        returnData.push({ column2: item.systemNumber, column3: item.name });
                    });
                    return returnData;
                })
                .value();
        },
        getExcelSheet() {
            const DATA = [
                {
                    column1: '停用帳號',
                    column2: this.userInfo.nam,
                    column3: this.userInfo.eml,
                },
                {
                    column1: '',
                    column2: '',
                    column3: '',
                },
                ...this.getExportDataRows(),
            ];

            const sheet = XLSX_STYLE.utils.json_to_sheet(DATA, { skipHeader: true });
            const widthSettings = [10, 20, 50];
            sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));

            // let color;
            _.forEach(sheet, (value, key) => {
                if (!key.includes('!')) {
                    const ROW = Number(key.substring(1));
                    if (sheet[key].v === '通過' || sheet[key].v === '未通過') {
                        const style = { fill: { fgColor: { rgb: sheet[key].v === '通過' ? 'CBDFB8' : 'F9DDDE' } } };

                        sheet[`A${ROW}`].s = style;
                        sheet[`B${ROW}`].s = style;
                        sheet[`C${ROW}`].s = style;
                    }
                }
            });

            return sheet;
        },

        getMappedData(data) {
            if (typeof data === 'boolean') return data;

            return data.map((o) => {
                let systemNumber;
                let name;

                switch (Object.keys(o).join(',')) {
                case 'sno,poo,nam':
                    name = o.nam;
                    systemNumber = o.poo;
                    break;
                case 'sno,payoo,nam':
                    name = o.nam;
                    systemNumber = o.payoo;
                    break;
                case 'sno,ioo,description':
                    name = o.description;
                    systemNumber = o.ioo;
                    break;
                default:
                    return o;
                }
                return { systemNumber, name };
            });
        },

        getPercent(amount, total) {
            return `${total ? ((amount / total) * 100).toFixed(2) : '0.00'}%`;
        },
    },
};
